import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { ContractResourceModalData } from "../../models/contract-resource.model";
import { HrRepository } from "../../repositories/hr.repository";

interface RetrieveContractResourceModalDataUseCaseParam {
  startDate: string;
  endDate: string;
}

export class RetrieveContractResourceModalDataUseCase
  implements
    UseCase<
      RetrieveContractResourceModalDataUseCaseParam,
      ContractResourceModalData
    >
{
  constructor(private repo: HrRepository) {}
  execute(
    param: RetrieveContractResourceModalDataUseCaseParam,
  ): Observable<ContractResourceModalData> {
    return this.repo.retrieveContractResourceModalData(
      param.startDate,
      param.endDate,
    );
  }
}

const retrieveContractResourceModalDataUseCaseFactory = (repo: HrRepository) =>
  new RetrieveContractResourceModalDataUseCase(repo);

export const retrieveContractResourceModalDataUseCaseProvider: Provider = {
  provide: RetrieveContractResourceModalDataUseCase,
  useFactory: retrieveContractResourceModalDataUseCaseFactory,
  deps: [HrRepository],
};
